
export const FETCH_DossierComplet_REQUEST = 'FETCH_DossierComplet_REQUEST';
export const FETCH_DossierComplet_SUCCESS = 'FETCH_DossierComplet_SUCCESS';
export const FETCH_DossierComplet_FAILURE = 'FETCH_DossierComplet_FAILURE';
export const REDIRECT_TO_LOGIN = 'REDIRECT_TO_LOGIN';